import { render, staticRenderFns } from "./Recover.vue?vue&type=template&id=15aabc33&scoped=true&lang=pug"
import script from "./Recover.vue?vue&type=script&lang=ts"
export * from "./Recover.vue?vue&type=script&lang=ts"
import style0 from "./Recover.vue?vue&type=style&index=0&id=15aabc33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aabc33",
  null
  
)

export default component.exports